import { styled } from 'stitches.config'

export const NoteRoot = styled('div', {
  border: '1px solid $secondary-600',
  borderRadius: '$4',
  backgroundColor: '$accent-menu-bo',
  padding: '$3',
  color: '$tertiary-900',

  variants: {
    variant: {
      error: {
        borderColor: '$primary-700',
      },
    },
  },
})
